<template>
    <v-app id="app">
        <loading-overlay-layer-legacy style="z-index: 9999;"/>

        <div>
            <keep-alive>
                <router-view/>
            </keep-alive>

            <dialog-overlay></dialog-overlay>
        </div>
    </v-app>
</template>

<script>
    import LoadingOverlayLayerLegacy from "@/assets/plugins/mps-dialog/loading-overlay/LoadingOverlayLayerLegacy";

    export default {
        name: "App",
        components: {LoadingOverlayLayerLegacy},
    }
</script>

<style lang="scss">
    @import 'assets/plugins/mps-form-table/css/form-table.css';
    @import './assets/css/main';

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;

    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
